export function unreachableValue(value: never): never {
	throw new TypeError(
		`Reached an unreachable value "${JSON.stringify(value)}"`,
	);
}
